import { device } from '@/styles/common';
import styled from 'styled-components';

function Background() {
  return <TopFold />;
}

const TopFold = styled.div``;

export default Background;
